// extracted by mini-css-extract-plugin
export var container = "_50-1";
export var cornerButtonContainer = "_50-5";
export var disabled = "_50-2";
export var fileContainer = "_50-4";
export var hiddenInput = "_50-3";
export var widthContainer = "_50-0";